// The grammar term registry: every `*.terms.ts` in this folder (./define.ts explains the shape).
import type { TermDef, TermText } from './define';

export type { TermDef, TermText } from './define';

const FILES = import.meta.glob<{ terms: Record<string, TermDef> }>('./*.terms.ts', { eager: true });

/** Every term, by id (an id declared twice is an error). */
export const TERMS: Readonly<Record<string, TermDef>> = (() => {
  const all: Record<string, TermDef> = {};
  for (const [file, m] of Object.entries(FILES).sort(([a], [b]) => a.localeCompare(b)))
    for (const [id, def] of Object.entries(m.terms)) {
      if (Object.prototype.hasOwnProperty.call(all, id)) throw new Error(`grammar term ${id} is declared twice (${file})`);
      all[id] = def;
    }
  return all;
})();

export function termById(id: string | null | undefined): TermDef | undefined {
  return id && Object.prototype.hasOwnProperty.call(TERMS, id) ? TERMS[id] : undefined;
}

/** A term's text in one UI language (the other one when that is missing). */
export function termText(def: TermDef, lang: 'fi' | 'en'): TermText {
  return lang === 'fi' ? def.fi : def.en;
}

/** The term name with a capital first letter (a sheet's title). */
export function termTitle(def: TermDef, lang: 'fi' | 'en'): string {
  const n = termText(def, lang).name;
  return n.charAt(0).toUpperCase() + n.slice(1);
}
